import { Routes, Route, Navigate } from "react-router-dom";
import KeyGen from "./Components/KeyGen/KeyGen";
import TitleGen from "./Components/TitleGen/TitleGen";

const DashboardRoutes = () => {
  return (
    <Routes>
      <Route index element={<div></div>} />
      <Route path="keygen" element={<KeyGen />} />
      <Route path="titlegen" element={<TitleGen />} />

      {/* REPLACE THIS WHEN YOU REPLACE DEFAULT ROUTE TO THE SAME COMPONENT */}
      <Route path="*" element={<Navigate to="/dashboard" replace={true} />} />
    </Routes>
  );
};

export default DashboardRoutes;
